<template>
  <div class="d-flex flex-column pa-2">
    <div class="d-flex justify-stretch w-full">
      <div class="w-1/3 pa-2">
        <CadastroCard :row="row" @reload="$emit('reload')" />
      </div>

      <div class="w-1/3 pa-2">
        <ContratoCard :row="row" @reload="$emit('reload')" />
      </div>

      <div class="w-1/3 pa-2">
        <ConfigMedicaoCard :row="row" @reload="$emit('reload')" />
      </div>
    </div>

    <div class="w-full pa-2">
      <ResumoMedicao />
    </div>
  </div>
</template>

<script>
import EditStore from './EditStore'
import ResumoMedicao from './ResumoMedicao.vue'
import CadastroCard from './CadastroCard.vue'
import ContratoCard from './ContratoCard.vue'
import ConfigMedicaoCard from './ConfigMedicaoCard.vue'

export default {
  components: { ResumoMedicao, CadastroCard, ContratoCard, ConfigMedicaoCard },
  data() {
    return {}
  },
  computed: {
    row() {
      return EditStore.row
    }
  },
  watch: {},
  methods: {}
}
</script>

<style lang="sass"></style>
